import EventValidator from '@/utils/validators/domain/Event'
import { photoNumberLengthError, photoNumberFormatError } from '@/const/errorMessage'

export interface Fields {
  // 改行コードで複数登録しているためstring
  photoNumbers: string
}

export type FieldErrors = { [key in keyof Fields]: string[] }

export default class PhotoSearchValidator {
  static validate(fields: Partial<Fields>): FieldErrors {
    const errors: FieldErrors = {
      photoNumbers: []
    }

    const validator = new EventValidator(fields)
    if (fields.photoNumbers !== undefined) {
      if (fields.photoNumbers) {
        if (!validator.isPhotoNumberFormatValid()) {
          errors.photoNumbers.push(photoNumberFormatError)
        }

        if (!validator.isPhotoNumberLengthValid()) {
          errors.photoNumbers.push(photoNumberLengthError)
        }
      }
    }
    return errors
  }
}
